
<div class="container">
  <div class="card">
    <div class="header-card">
      <h2 class="title-main">{{'InvitationCodePage.MessageRequestCode' | translate}}</h2>
      <p class="text">{{'InvitationCodePage.MessageTextRequestCode' | translate}}.</p>
    </div>
    <form [formGroup]="formGroup">
      <div class="container-form">
        <!-- <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
          <label for="language" style="font-weight: bold;">{{'InvitationCodePage.LanguageFieldLabel' | translate }} *</label>
          <p-dropdown
            [options]="langs"
            inputId="language"
            optionLabel="label"
            optionValue="lang"
            formControlName="language"
            (onChange)="switchLang()"
            [showClear]="false"
            placeholder="{{ 'InvitationCodePage.LanguageFieldPlaceholder' | translate}}">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center">
                <img [flag]="lang.icon" style="width: 18px" alt="" *ngIf="lang"/>
                <span>&nbsp;{{lang?.label}}</span>
              </div>
            </ng-template>
            <ng-template let-lang pTemplate="item">
              <div class="flex align-items-center">
                <img [flag]="lang.icon" style="width: 18px" alt=""/>
                <span>&nbsp;{{lang.label}}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <small *ngIf="submit && formGroup.controls['language'].invalid" class="p-error">{{getErrorMessage('language')}}</small>
        </div> -->
        <div class="field col-12">
          <label for="fullname" class="label-form">{{'InvitationCodePage.FullNameLabel' | translate }} *</label>
          <input class="input-requests-code" id="fullname" formControlName="fullname" type="text" maxlength="120" required pInputText [(ngModel)]="fullname"/>
          <small *ngIf="submit && formGroup.controls['fullname'].invalid" class="p-error">{{getErrorMessage('fullname')}}</small>
        </div>
        <div class="field col-12" style="margin-bottom: 30px;">
          <label for="email" class="label-form">{{'InvitationCodePage.EmailFieldLabel' | translate }} *</label>
          <input class="input-requests-code" id="email" formControlName="email" type="text" maxlength="50" required pInputText [(ngModel)]="email"/>
          <small *ngIf="submit && formGroup.controls['email'].invalid" class="p-error">{{getErrorMessage('email')}}</small>
        </div>
        <div class="field col-12" style="margin-bottom: 20px;">
          <div class=" w-full">
            <button pButton style="width:100%; display:flex; justify-content:center" (click)="generateCode()" [loading]="loading">{{'InvitationCodePage.RequestCode' | translate}}</button>
          </div>
        </div>
        <div class="field col-12" style="margin-bottom: 20px;" *ngIf="showBackLogin">
          <div class=" w-full">
            <p-button label="{{'InvitationCodePage.BackButton' | translate}}" [disabled]="loading" (onClick)="onCancel()"/>
          </div>
        </div>

      </div>
    </form>
  </div>
</div>
